import { useCallback } from 'react'

import { type Sorter } from '../models'

type NavigateOptions<T> = {
  search: T
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NavigateFn<T> = (options: NavigateOptions<T>) => any

/**
 * ソート変更時のナビゲーション処理を行うフック
 * @param search 現在の検索条件
 * @param navigate ナビゲーション関数
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSortNavigation = <T extends Record<string, any>>(
  search: T,
  navigate: NavigateFn<T>
) => {
  const handleSortChange = useCallback(
    ({ sort, order }: Sorter) => {
      navigate({
        search: {
          ...search,
          sort,
          order
        }
      })
    },
    [search, navigate]
  )

  return handleSortChange
}
